export const translations = {
  fr: {
    brand: "ServiMatch",
    tagline: "La référence pour connecter clients et travailleurs autonomes",
    nav_feed: "Demandes",
    nav_pricing: "Forfaits",
    nav_post: "Publier une demande",
    nav_dashboard: "Tableau de bord",
    nav_client: "Mes demandes",
    nav_pros: "Pros",
    pros_title: "Trouvez le bon travailleur",
    pros_sub: "Parcourez les travailleurs autonomes par métier, ville et évaluations.",
    reviews: "avis",
    years_exp: "ans d'exp.",
    leave_review: "Laisser un avis",
    your_rating: "Votre note",
    comment: "Commentaire",
    submit_review: "Publier l'avis",
    no_reviews: "Aucun avis pour l'instant.",
    edit_profile: "Modifier mon profil",
    profile_title: "Mon profil professionnel",
    display_name: "Nom affiché",
    trade_label: "Métiers",
    city_label: "Ville",
    bio_label: "Présentation",
    years_label: "Années d'expérience",
    photo_label: "Photo de profil",
    save_profile: "Enregistrer le profil",
    back: "Retour",
    login: "Connexion",
    logout: "Déconnexion",
    register: "S'inscrire",
    get_started: "Commencer",
    hero_title: "Ne manquez plus jamais une demande de service",
    trial_banner: "Essai gratuit de 7 jours sur tous les forfaits payants — sans engagement",
    trial_banner_cta: "Commencer l'essai",
    hero_sub: "ServiMatch rassemble en temps réel les demandes de services publiées en ligne et les livre directement aux travailleurs autonomes, filtrées par secteur et localisation.",
    hero_cta: "Voir les demandes",
    hero_cta2: "Découvrir les forfaits",
    stat_leads: "Demandes actives",
    stat_sectors: "Secteurs couverts",
    stat_cities: "Villes desservies",
    how_title: "Comment ça marche",
    how1_t: "Les clients publient",
    how1_d: "Les clients décrivent leur besoin de service en quelques secondes.",
    how2_t: "Nous agrégeons",
    how2_d: "Les demandes sont classées par secteur d'opération et localisation.",
    how3_t: "Vous recevez",
    how3_d: "Recevez les demandes pertinentes et contactez le client avant les autres.",
    features_title: "Le meilleur atout des travailleurs autonomes",
    post_title: "Publier une demande de service",
    post_sub: "Décrivez votre besoin, un professionnel vous contactera rapidement.",
    f_title: "Titre de la demande",
    f_sector: "Secteur d'opération",
    f_location: "Localisation",
    f_budget: "Budget estimé",
    f_urgency: "Urgence",
    f_desc: "Description",
    f_name: "Votre nom",
    f_email: "Courriel",
    f_phone: "Téléphone",
    f_submit: "Publier la demande",
    urgency_normal: "Normal",
    urgency_urgent: "Urgent",
    feed_title: "Demandes de services",
    feed_sub: "Demandes en direct, filtrées pour vous.",
    filter_sector: "Tous les secteurs",
    filter_location: "Toutes les localisations",
    filter_urgency: "Toutes urgences",
    unlock: "Débloquer le contact",
    unlocked: "Contact débloqué",
    locked_hint: "Abonnez-vous pour voir les coordonnées",
    view_pricing: "Voir les forfaits",
    pricing_title: "Choisissez votre forfait",
    pricing_sub: "Recevez plus de demandes, dans plus de secteurs et de villes.",
    per_month: "/mois",
    plus_tax: "+ taxes applicables",
    leads_mo: "demandes / mois",
    sectors_n: "secteur(s)",
    locations_n: "localisation(s)",
    unlimited: "Illimité",
    all_sectors: "Tous les secteurs",
    all_locations: "Toutes les villes",
    subscribe: "S'abonner",
    subscribe_trial: "Essayer 7 jours gratuits",
    trial_note: "7 jours gratuits, puis",
    free_name: "Gratuit",
    free_tag: "Pour commencer",
    free_f1: "Lire toutes les demandes",
    free_f2: "1 demande par semaine",
    free_f3: "Sans alertes courriel",
    start_free: "Commencer gratuitement",
    leads_wk: "demande / semaine",
    dash_usage_week: "Demandes débloquées cette semaine",
    upgrade_plan: "Augmenter mon forfait",
    free_hint: "Vous êtes sur le forfait Gratuit : 1 demande par semaine, sans alertes courriel.",
    missed_title: "Vous ratez des opportunités",
    missed_label: "contacts manqués cette semaine",
    missed_cta: "Débloquez-les tous — passez à un forfait payant",
    captured_title: "Beau travail ce mois-ci !",
    captured_label: "contacts captés ce mois",
    captured_sub: "Continuez ainsi — chaque contact débloqué est une opportunité de contrat.",
    current_plan: "Forfait actuel",
    popular: "Populaire",
    dash_title: "Tableau de bord",
    dash_plan: "Votre forfait",
    dash_usage: "Demandes débloquées ce mois",
    dash_prefs: "Vos préférences",
    dash_prefs_sub: "Sélectionnez vos secteurs et localisations à suivre.",
    save_prefs: "Enregistrer",
    no_sub: "Aucun abonnement actif",
    choose_plan: "Choisir un forfait",
    my_requests: "Mes demandes publiées",
    login_title: "Bon retour",
    register_title: "Créer un compte",
    email: "Courriel",
    password: "Mot de passe",
    name: "Nom complet",
    role: "Je suis un(e)",
    role_freelancer: "Travailleur autonome",
    role_client: "Client",
    continue_google: "Continuer avec Google",
    or: "ou",
    no_account: "Pas de compte ?",
    have_account: "Déjà un compte ?",
    posted_ago: "Publié il y a",
    urgent_badge: "Urgent",
    footer_rights: "Tous droits réservés.",
    pay_success: "Paiement réussi !",
    pay_success_sub: "Votre abonnement est activé.",
    pay_cancel: "Paiement annulé",
    pay_cancel_sub: "Aucun montant n'a été prélevé.",
    go_dash: "Aller au tableau de bord",
    processing: "Traitement en cours...",
  },
  en: {
    brand: "ServiMatch",
    tagline: "The reference connecting clients and freelancers",
    nav_feed: "Requests",
    nav_pricing: "Plans",
    nav_post: "Post a request",
    nav_dashboard: "Dashboard",
    nav_client: "My requests",
    nav_pros: "Pros",
    pros_title: "Find the right worker",
    pros_sub: "Browse freelancers by trade, city and ratings.",
    reviews: "reviews",
    years_exp: "yrs exp.",
    leave_review: "Leave a review",
    your_rating: "Your rating",
    comment: "Comment",
    submit_review: "Post review",
    no_reviews: "No reviews yet.",
    edit_profile: "Edit my profile",
    profile_title: "My professional profile",
    display_name: "Display name",
    trade_label: "Trades",
    city_label: "City",
    bio_label: "About",
    years_label: "Years of experience",
    photo_label: "Profile photo",
    save_profile: "Save profile",
    back: "Back",
    login: "Log in",
    logout: "Log out",
    register: "Sign up",
    get_started: "Get started",
    hero_title: "Never miss a service request again",
    trial_banner: "7-day free trial on all paid plans — no commitment",
    trial_banner_cta: "Start trial",
    hero_sub: "ServiMatch aggregates service requests posted online in real time and delivers them straight to freelancers, filtered by sector and location.",
    hero_cta: "Browse requests",
    hero_cta2: "See the plans",
    stat_leads: "Active requests",
    stat_sectors: "Sectors covered",
    stat_cities: "Cities served",
    how_title: "How it works",
    how1_t: "Clients post",
    how1_d: "Clients describe their service need in seconds.",
    how2_t: "We aggregate",
    how2_d: "Requests are sorted by operation sector and location.",
    how3_t: "You receive",
    how3_d: "Get relevant requests and reach the client before anyone else.",
    features_title: "The freelancer's best asset",
    post_title: "Post a service request",
    post_sub: "Describe your need and a professional will contact you quickly.",
    f_title: "Request title",
    f_sector: "Operation sector",
    f_location: "Location",
    f_budget: "Estimated budget",
    f_urgency: "Urgency",
    f_desc: "Description",
    f_name: "Your name",
    f_email: "Email",
    f_phone: "Phone",
    f_submit: "Post request",
    urgency_normal: "Normal",
    urgency_urgent: "Urgent",
    feed_title: "Service requests",
    feed_sub: "Live requests, filtered for you.",
    filter_sector: "All sectors",
    filter_location: "All locations",
    filter_urgency: "All urgencies",
    unlock: "Unlock contact",
    unlocked: "Contact unlocked",
    locked_hint: "Subscribe to view contact details",
    view_pricing: "View plans",
    pricing_title: "Choose your plan",
    pricing_sub: "Receive more requests, across more sectors and cities.",
    per_month: "/month",
    plus_tax: "+ applicable taxes",
    leads_mo: "requests / month",
    sectors_n: "sector(s)",
    locations_n: "location(s)",
    unlimited: "Unlimited",
    all_sectors: "All sectors",
    all_locations: "All cities",
    subscribe: "Subscribe",
    subscribe_trial: "Start 7-day free trial",
    trial_note: "7 days free, then",
    free_name: "Free",
    free_tag: "To get started",
    free_f1: "Read all requests",
    free_f2: "1 request per week",
    free_f3: "No email alerts",
    start_free: "Start for free",
    leads_wk: "request / week",
    dash_usage_week: "Requests unlocked this week",
    upgrade_plan: "Upgrade my plan",
    free_hint: "You're on the Free plan: 1 request per week, no email alerts.",
    missed_title: "You're missing opportunities",
    missed_label: "contacts missed this week",
    missed_cta: "Unlock them all — upgrade to a paid plan",
    captured_title: "Great month so far!",
    captured_label: "contacts captured this month",
    captured_sub: "Keep it up — every unlocked contact is a potential contract.",
    current_plan: "Current plan",
    popular: "Popular",
    dash_title: "Dashboard",
    dash_plan: "Your plan",
    dash_usage: "Requests unlocked this month",
    dash_prefs: "Your preferences",
    dash_prefs_sub: "Select the sectors and locations to follow.",
    save_prefs: "Save",
    no_sub: "No active subscription",
    choose_plan: "Choose a plan",
    my_requests: "My posted requests",
    login_title: "Welcome back",
    register_title: "Create an account",
    email: "Email",
    password: "Password",
    name: "Full name",
    role: "I am a",
    role_freelancer: "Freelancer",
    role_client: "Client",
    continue_google: "Continue with Google",
    or: "or",
    no_account: "No account?",
    have_account: "Already have an account?",
    posted_ago: "Posted",
    urgent_badge: "Urgent",
    footer_rights: "All rights reserved.",
    pay_success: "Payment successful!",
    pay_success_sub: "Your subscription is active.",
    pay_cancel: "Payment cancelled",
    pay_cancel_sub: "No amount was charged.",
    go_dash: "Go to dashboard",
    processing: "Processing...",
  },
};
